import type { ModelDefinition } from "@/models.js";

export const atlascloudModels = [
	{
		id: "kling-v3-0",
		name: "KLING v3.0",
		description:
			"AtlasCloud KLING v3.0 video generation. Routes text, image, duration, and 4K requests to the matching upstream KLING v3.0 model.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 10,
		stability: "beta",
		releasedAt: new Date("2026-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "kwaivgi/kling-v3.0",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.126",
					default_video: "0.084",
					"720p_audio": "0.126",
					"720p_video": "0.084",
					"1080p_audio": "0.168",
					"1080p_video": "0.112",
					"4k_audio": "0.42",
					"4k_video": "0.42",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: [
					"1280x720",
					"720x1280",
					"1920x1080",
					"1080x1920",
					"3840x2160",
					"2160x3840",
				],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "kling-v3-0-turbo",
		name: "KLING v3.0 Turbo",
		description:
			"AtlasCloud KLING v3.0 Turbo video generation. Routes text, image, and duration requests to the matching upstream KLING v3.0 Turbo model.",
		family: "atlascloud",
		output: ["video"],
		maxVideoDurationSeconds: 10,
		stability: "beta",
		releasedAt: new Date("2026-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "atlascloud",
				externalId: "kwaivgi/kling-v3.0-turbo",
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.168",
					"720p_audio": "0.168",
					"1080p_audio": "0.21",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: false,
			},
		],
	},
] as const satisfies ModelDefinition[];
